<div class="bg-surface-100 dark:bg-surface-950 px-6 md:px-12 lg:px-20 py-20 text-center">
	<div class="flex flex-col gap-6 pb-10">
		<div class="flex flex-col items-center gap-4">
			<app-headline-large [title]="content.title"></app-headline-large>
			<app-body-large [description]="content.description"></app-body-large>
		</div>

		@if (content.copy.length > 0){
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
			@for (item of content.copy; track item.title) {
			<div
				pAnimateOnScroll
				enterClass="animate-enter fade-in-10 zoom-in-75 animate-duration-1000"
				class="bg-surface-0 p-4 shadow-md">
				<span class="mb-4 flex h-16 w-16 items-center justify-center bg-primary-50 dark:bg-surface-800 mx-auto">
					<i
						[ngClass]="item?.image?.src"
						class="text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
				</span>
				<div class="flex flex-col gap-1">
					@if (item.title.length > 0){
					<h3
						class="text-surface-900 dark:text-surface-0 text-xl font-semibold leading-tight"
						[innerHTML]="item.title"></h3>
					} @if (item.description.length > 0){
					<app-body-large [description]="item.description"></app-body-large>
					}
				</div>
			</div>
			}
		</div>
		}
	</div>
	@if (content.link){
	<app-link
		[type]="content.link.type"
		[routerLink]="content.link.path"
		[label]="content.link.title"
		bgColor="light"></app-link>
	}
</div>
